var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["range-slider j-range-slider", _vm.modify] }, [
    _c("div", { staticClass: "range-slider__inputs" }, [
      _c("div", { staticClass: "range-slider__wrap-input" }, [
        _c("span", { staticClass: "range-slider__input-label" }, [
          _vm._v(_vm._s(_vm.prefixFrom || "от"))
        ]),
        _vm._v(" "),
        _c("input", {
          staticClass: "range-slider__input j-range-slider-from",
          attrs: { type: "tel", name: _vm.name + "[min]", autocomplete: "off" },
          domProps: { value: _vm.from }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass:
              "range-slider__input-label range-slider__input-label_right_side"
          },
          [_vm._v(_vm._s(_vm.postfix))]
        )
      ]),
      _vm._v(" "),
      !_vm.single
        ? _c("div", { staticClass: "range-slider__wrap-input" }, [
            _c("span", { staticClass: "range-slider__input-label" }, [
              _vm._v(_vm._s(_vm.prefixTo || "до"))
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "range-slider__input j-range-slider-to",
              attrs: {
                type: "tel",
                name: _vm.name + "[max]",
                autocomplete: "off"
              },
              domProps: { value: _vm.to }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "range-slider__input-label range-slider__input-label_right_side"
              },
              [_vm._v(_vm._s(_vm.postfix))]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "range-slider__base" }, [
      _c("input", {
        staticClass: "j-range-slider-base",
        attrs: { id: _vm.name, type: "text" }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }